import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rem } from 'polished';

const Wrapper = styled.label`
  display: inline-block;
  align-items: center;
  font-size: ${rem(14)};
  cursor: pointer;
  letter-spacing: 0.1px;
  ${props => {
    if (props.required) {
      return `
      &:after {
        content: ' *';
        color: ${props.theme.color.primary};
      }`;
    }
    return null;
  }};
`;

const Label = (props, context) => {
  const { children, className, required } = props;
  return (
    <Wrapper
      htmlFor={props.htmlFor || context.id}
      className={className}
      required={required}
    >
      {children}
    </Wrapper>
  );
};

Label.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  htmlFor: PropTypes.string,
  required: PropTypes.bool,
};
Label.defaultProps = {
  className: '',
  children: null,
  htmlFor: null,
  required: false,
};

Label.contextTypes = {
  id: PropTypes.string,
};

export default Label;



// WEBPACK FOOTER //
// ./src/components/Label/index.js